import { Link } from 'react-router-dom';
import { BadgeCheck, ArrowRight } from 'lucide-react';

export const BDAF_TIERS = {
  5: { label: 'AI-Ready', color: '#1A4D3A', bg: '#ECFDF5', border: '#A7F3D0' },
  4: { label: 'Active', color: '#1A4D3A', bg: '#ECFDF5', border: '#A7F3D0' },
  3: { label: 'Active', color: '#1A4D3A', bg: '#ECFDF5', border: '#A7F3D0' },
  2: { label: 'Emerging', color: '#B45309', bg: '#FFFBEB', border: '#FDE68A' },
  1: { label: 'At Risk', color: '#DC2626', bg: '#FEF2F2', border: '#FECACA' },
  0: { label: 'Invisible', color: '#DC2626', bg: '#FEF2F2', border: '#FECACA' },
};

export const tierFor = (score) => BDAF_TIERS[Math.max(0, Math.min(5, Number(score) || 0))];

// BDAF dot cluster — five dots, filled = signal detected
export function BDAFDots({ score = 0, size = 8, showLabel = false, className = '' }) {
  const t = tierFor(score);
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid="bdaf-dots" title={`BDAF ${score}/5 · ${t.label}`}>
      <span className="inline-flex items-center" style={{ gap: size / 2 }}>
        {[0, 1, 2, 3, 4].map(i => (
          <span key={i} className="rounded-full block transition-colors" style={{ width: size, height: size, background: i < score ? t.color : `${t.color}26` }} />
        ))}
      </span>
      {showLabel && <span className="font-body text-xs font-medium" style={{ color: t.color }}>{score} / {t.label}</span>}
    </span>
  );
}

export function BDAFTierPill({ score, className = '' }) {
  const t = tierFor(score);
  return (
    <span data-testid="bdaf-tier-pill" className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-body text-[11px] font-semibold border ${className}`}
      style={{ color: t.color, background: t.bg, borderColor: t.border }}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: t.color }} /> {t.label}
    </span>
  );
}

// Claim status: verified / claimed (pending) / unclaimed → orange "Claim →" pill
export function ClaimBadge({ business, size = 'sm', stopPropagation = true }) {
  const status = business?.claim_status;
  const pad = size === 'md' ? 'px-3 py-1 text-xs' : 'px-2 py-0.5 text-[11px]';
  if (status === 'verified') return (
    <span data-testid="claim-badge-verified" className={`inline-flex items-center gap-1 rounded-full font-body font-semibold border ${pad}`} style={{ color: '#1A4D3A', background: '#ECFDF5', borderColor: '#A7F3D0' }}>
      <BadgeCheck className="w-3 h-3" strokeWidth={2.5} /> Verified
    </span>
  );
  if (status === 'pending' || business?.claimed_by) return (
    <span data-testid="claim-badge-claimed" className={`inline-flex items-center rounded-full font-body font-medium border ${pad}`} style={{ color: '#374151', background: '#F5F0E8', borderColor: '#E8E4DC' }}>Claimed</span>
  );
  return (
    <Link to={`/claim/${business?.id}`} onClick={e => stopPropagation && e.stopPropagation()} data-testid="claim-pill"
      className={`inline-flex items-center gap-1 rounded-full font-body font-semibold text-white transition-colors hover:bg-[#D93A1C] ${pad}`} style={{ background: '#FE4A2A' }}>
      Claim <ArrowRight className="w-3 h-3" strokeWidth={2.5} />
    </Link>
  );
}
